import * as Types from '@/types';

import { CompleteTranslationFieldsFragmentDoc } from '@/experiences/sales-portal/blocs/documents/sales-portal-translation-fragments.generated';
import { gql } from '@apollo/client';
import { PriceEditDisplayInfoDetailFieldsFragmentDoc } from '@/experiences/sales-portal/blocs/documents/sales-portal-price-edit-display-info-fragments.generated';
import { PricingInvoiceHistoryFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/blocs/documents/pricing-invoice-history-fragment.generated';
import { PricingWeeklyPurchaseQuantityFieldsFragmentDoc } from '@/experiences/sales-portal/domain/pricing/blocs/documents/pricing-weekly-purchase-quantity-fragment.generated';
export const VariantPackGroupMembershipFieldsFragmentDoc = gql`
  fragment VariantPackGroupMembershipFields on VariantPackGroupMembership {
    uuid
    display_name
    source
  }
`;
export const RestaurantCostChangeFieldsFragmentDoc = gql`
  fragment RestaurantCostChangeFields on businesses {
    name
    uuid
  }
`;
export const VariantPackCostChangeFieldsFragmentDoc = gql`
  fragment VariantPackCostChangeFields on variants_packs {
    external_item_id
    item {
      display_name
      uuid
    }
    pack {
      unit
      uuid
    }
    uuid
  }
`;
export const VariantPackCostChangeDataFieldsFragmentDoc = gql`
  fragment VariantPackCostChangeDataFields on OrgVariantPackCostChange {
    cost_in_micros
    cost_in_micros_delta
    gross_margin_delta_in_micros
    gross_profit_percentage
    groups {
      ...VariantPackGroupMembershipFields
    }
    price_in_micros
    price_in_micros_delta
    restaurant {
      ...RestaurantCostChangeFields
    }
    supplier_id
    variant_pack {
      ...VariantPackCostChangeFields
    }
    weekly_quantity
  }
  ${VariantPackGroupMembershipFieldsFragmentDoc}
  ${RestaurantCostChangeFieldsFragmentDoc}
  ${VariantPackCostChangeFieldsFragmentDoc}
`;
export const PricingPeerGroupFieldsFragmentDoc = gql`
  fragment PricingPeerGroupFields on PricingPeerGroup {
    id
    min_gross_profit_in_percentage
    max_gross_profit_in_percentage
  }
`;
export const VariantPackDetailedCostChangeDataFieldsFragmentDoc = gql`
  fragment VariantPackDetailedCostChangeDataFields on DetailVariantPackCostChange {
    cost_in_micros
    cost_in_micros_delta
    gross_margin_delta_in_micros
    gross_profit_percentage
    groups {
      ...VariantPackGroupMembershipFields
    }
    invoice_history {
      ...PricingInvoiceHistoryFields
    }
    is_locked
    price_floor_enabled
    price_floor_mode
    price_in_micros
    price_in_micros_delta
    price_edit_display_headers {
      key
      category
      translation {
        ...CompleteTranslationFields
      }
    }
    pricing_peer_group {
      ...PricingPeerGroupFields
    }
    restaurant {
      ...RestaurantCostChangeFields
    }
    restaurant_account_id
    supplier_display_info {
      ...PriceEditDisplayInfoDetailFields
    }
    supplier_id
    variant_pack {
      ...VariantPackCostChangeFields
    }
    weekly_purchase_quantities {
      ...PricingWeeklyPurchaseQuantityFields
    }
    weekly_quantity
  }
  ${VariantPackGroupMembershipFieldsFragmentDoc}
  ${PricingInvoiceHistoryFieldsFragmentDoc}
  ${CompleteTranslationFieldsFragmentDoc}
  ${PricingPeerGroupFieldsFragmentDoc}
  ${RestaurantCostChangeFieldsFragmentDoc}
  ${PriceEditDisplayInfoDetailFieldsFragmentDoc}
  ${VariantPackCostChangeFieldsFragmentDoc}
  ${PricingWeeklyPurchaseQuantityFieldsFragmentDoc}
`;
